module.exports = __webpack_public_path__ + "img/roll-435.1b9fa840.png";